import i18n from "../i18n";
import apiErrorMessages from "./apiErrorMessages";

/**
 * Translate an error that came back from hubb-sms-lambda.
 * The backend only returns English, so known messages and codes are looked up
 * in the apiErrors namespace. Unknown messages are shown as they are.
 *
 * @param {Object|string} error - { code, message } or a plain message string
 * @param {string} [fallback] - text to use when there is no message at all
 * @returns {string}
 */
export const translateApiError = (error, fallback) => {
  const code = typeof error === "object" ? error?.code : undefined;
  const message = typeof error === "string" ? error : error?.message;
  const trimmed = typeof message === "string" ? message.trim() : "";

  // The backend already speaks English, so English users see its own text.
  if (trimmed && i18n.language?.startsWith("en")) return trimmed;

  // A known message is more specific than its code, so it is checked first.
  if (trimmed) {
    for (const entry of apiErrorMessages) {
      const match =
        typeof entry.match === "string"
          ? entry.match === trimmed && []
          : trimmed.match(entry.match);
      if (match) {
        // Named groups become interpolation values, e.g. {{email}}
        return String(
          i18n.t(`apiErrors.messages.${entry.key}`, match.groups || {})
        );
      }
    }
  }

  if (code && i18n.exists(`apiErrors.codes.${code}`)) {
    return String(i18n.t(`apiErrors.codes.${code}`));
  }

  if (trimmed) return trimmed;

  return fallback || String(i18n.t("common.genericError"));
};

export default translateApiError;
